var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.init
    ? _c(
        "div",
        { staticClass: "status-wrapper" },
        [
          _vm.checkResponse == null
            ? [
                _vm.contact
                  ? _c(
                      "div",
                      {
                        staticClass: "registered loading",
                        class: { light: _vm.hideInfo },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "peppol-check mrs" },
                          [
                            _c("w-fa", {
                              staticClass: "mrs fa-spin",
                              attrs: { icon: "circle-notch" },
                            }),
                            _vm._v("PEPPOL"),
                          ],
                          1
                        ),
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.hideInfo ? _vm.contact.getDisplayName() : ""
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            : _vm.partialCompatibility != ""
            ? [
                _vm.contact
                  ? _c(
                      "div",
                      {
                        staticClass: "registered partial",
                        class: {
                          light: _vm.hideInfo,
                          false: _vm.noCompatibility,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "peppol-check mrs" },
                          [
                            _c("w-fa", {
                              staticClass: "mrs",
                              attrs: { icon: "check" },
                            }),
                            _vm._v("PEPPOL"),
                          ],
                          1
                        ),
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.hideInfo ? _vm.contact.getDisplayName() : ""
                            ) +
                            " (" +
                            _vm._s(_vm.partialCompatibility) +
                            ") "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            : _vm.checkResponse.Registered
            ? [
                _vm.contact
                  ? _c(
                      "div",
                      {
                        staticClass: "registered",
                        class: { light: _vm.hideInfo },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "peppol-check mrs" },
                          [
                            _c("w-fa", {
                              staticClass: "mrs",
                              attrs: { icon: "check" },
                            }),
                            _vm._v("PEPPOL"),
                          ],
                          1
                        ),
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.hideInfo ? _vm.contact.getDisplayName() : ""
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            : [
                _vm.contact && _vm.init
                  ? _c(
                      "div",
                      {
                        staticClass: "registered false",
                        class: { light: _vm.hideInfo },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "peppol-check mrs" },
                          [
                            _c("w-fa", {
                              staticClass: "mrs",
                              attrs: { icon: "times" },
                            }),
                            _vm._v("PEPPOL"),
                          ],
                          1
                        ),
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.hideInfo
                                ? _vm.$ct("not-registered", {
                                    name: _vm.contact.getDisplayName(),
                                  })
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }